module.exports = __webpack_public_path__ + "media/partners/cannes-8e70aebd.png";